import { fetchBaseQuery } from "@reduxjs/toolkit/query";
// @ts-ignore: Importing from app config directly as requested
import { domainConfigs } from "../../../../apps/web/src/config/domains";

// Resolve the active hostname:
// 1) On localhost, allow a manual override via localStorage('domainOverride')
//    so the Navbar "Switch Client" dropdown also points the backend URL
//    at the selected domain's apiUrl.
// 2) Otherwise fall back to the actual window hostname.
// 3) On the server (no window), use the 'default' config.
const getActiveHostname = (): string => {
  if (typeof window === 'undefined') return 'default';
  try {
    const override = window.localStorage?.getItem('domainOverride');
    if (override) return override;
  } catch {
    // localStorage may be unavailable (SSR/private mode) — ignore and fall back.
  }
  return window.location.hostname;
};

const hostname = getActiveHostname();

const domainConfig = domainConfigs[hostname] || domainConfigs['default'];

const apiUrl = domainConfig?.apiUrl;
const encryptStatus = domainConfig?.encrypt;

export const baseQuery = fetchBaseQuery({
  baseUrl: apiUrl,
  // baseUrl: "http://localhost:3002",
  prepareHeaders: (headers) => {
    let token = ""; //get from local storage
    headers.set("content-type", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    headers.set("x-accept-encoding", encryptStatus == 'Y' ? "enabled" : "denied");
    if (token) {
      headers.set("Auth", `${token}`);
    }
  },
});
